import { createFileRoute } from "@tanstack/react-router";
import { MenuImportReview } from "../../features/ai/menu-import-review";

export const Route = createFileRoute("/restaurants/$restaurantId_/menu-import_/$importId")({
	component: Page,
});

function Page() {
	const { restaurantId, importId } = Route.useParams();
	return <MenuImportReview key={importId} restaurantId={restaurantId} importId={importId} />;
}
